module.exports = __webpack_public_path__ + "img/pu_old.c53105f7.png";